import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient) { }

  getListOfCountries(): Observable<any> {
    return this.http.get(`assets/mockdata/countries.json`);
  }
}
